export async function init(element) {
	const wrapper = element.querySelector('.swiper-wrapper');

	if (wrapper.children.length === 1)
		return;

	const { default: Swiper } = await import('swiper/bundle');

	return new Swiper(element, {
		loop: false,
		freemode: true,
		breakpoints: {
			0: {
				slidesPerView: 1,
			},
			775: {
				slidesPerView: 'auto',
			},
			1400: {
				slidesPerView: 3,
			},
		},
	});
}

export async function initAll([element, ...elements]) {
	if (element)
		await init(element);

	if (elements.length)
		return await initAll(elements);
}

document.addEventListener('DOMContentLoaded', () => initAll(document.querySelectorAll('.homepage-carousel')));
